import React, { useMemo, useEffect } from "react";
import CardTable from "components/CardTable/CardTable";
import { useOpenComponent } from "hooks/useOpenComponent";

import { useDispatch, useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import { columns } from "./columns";

import RegularButton from "components/CustomButtons/Button";
import { Home } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";
import { ModalV2 } from "components/Modal/ModalV2";

import { MODELS_PHRASE } from "./config";
import { ModelsForm } from "./ModelsForm";
import { newBrandModel } from "redux/actions/buildings/brands/brandsMetersActions";

const LOADINGS = [
  "getBrandsMeters",
  "fetchNewBrandModel",
  "fetchEditBrandModel"
];

export const ModelsPage = () => {
  const dispatch = useDispatch();
  const { isOpen, handleIsOpen } = useOpenComponent();

  const { clearSearch, buildCompLoadings } = useSearch();
  const { modelsList, isAddMode, deleteMode } = useSelector(state => state.brandsMeters);
  const { isLoadingComp } = useSelector(
    state => state.search
  );

  const modelsMemo = useMemo(
    () =>
      modelsList?.map(model => {
        return {
          ...model,
          modal: handleIsOpen
        };
      }),
    [modelsList]
  );

  const handleClose = () => {
    handleIsOpen();
  };

  const handleOpenAdd = () => {
    dispatch(newBrandModel());
    handleIsOpen();
  };

  useEffect(() => {
    clearSearch();
  }, [clearSearch]);

  useEffect(() => {
    buildCompLoadings(LOADINGS);
  }, []);

  return (
    <React.Fragment>
      <CardTable
        data={modelsMemo}
        columns={columns}
        loading={isLoadingComp.getBrandsMeters}
        title={MODELS_PHRASE.page.table.title}
        icon={<Home />}
        hasHeader
        blockBtn
        hasControl
        controls={
          true && (
            <RegularButton
              round
              justIcon
              color="info"
              style={{ margin: 10 }}
              onClick={handleOpenAdd}
              size="sm"
            >
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          )
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={isAddMode
          ? MODELS_PHRASE.modal.titles.add
          : deleteMode
            ? MODELS_PHRASE.modal.titles.delete
            : MODELS_PHRASE.modal.titles.edit}
      >
        {<ModelsForm handleClose={handleClose} />}
      </ModalV2>
    </React.Fragment>
  );
};
